import { useEffect, useState } from "react";

export const useAutoTableHeight = (offset = 260) => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    let timeout;

    const handleResize = () => {
      clearTimeout(timeout);
      timeout = window.setTimeout(() => {
        setHeight(window.innerHeight - offset);
      }, 100);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", handleResize);
    };
  }, [offset]);

  return height;
};
